var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContext = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DFBD0A",
  d: "M56.273 21.59a.5.5 0 0 1 .5-.5H61.5a.5.5 0 0 1 .5.5v2.82a.5.5 0 0 1-.5.5h-4.727a.5.5 0 0 1-.5-.5v-2.82ZM20 21.59a.5.5 0 0 1 .5-.5h4.727a.5.5 0 0 1 .5.5v2.82a.5.5 0 0 1-.5.5H20.5a.5.5 0 0 1-.5-.5v-2.82ZM42.41 2a.5.5 0 0 1 .5.5v4.727a.5.5 0 0 1-.5.5h-2.82a.5.5 0 0 1-.5-.5V2.5a.5.5 0 0 1 .5-.5h2.82ZM27.13 7.13a.5.5 0 0 1 .708 0l3.359 3.373a.5.5 0 0 1-.002.708L29.192 13.2a.5.5 0 0 1-.705 0l-3.36-3.345a.5.5 0 0 1-.002-.707l2.004-2.018Zm23.673 4.062a.5.5 0 0 1-.001-.707l3.342-3.357a.5.5 0 0 1 .708 0l2.02 2.02a.5.5 0 0 1 0 .708l-3.358 3.342a.5.5 0 0 1-.706 0l-2.005-2.006Zm-6.485 28.99a.5.5 0 0 1 .5.5v1.409A1.91 1.91 0 0 1 42.91 44h-3.818a1.909 1.909 0 0 1-1.91-1.91v-1.408a.5.5 0 0 1 .5-.5h6.637Zm-5.227-6.227a.5.5 0 0 0 .5.5h2.818a.5.5 0 0 0 .5-.5v-3.178c0-.229.156-.427.374-.494A7.622 7.622 0 0 0 48.636 23a7.636 7.636 0 0 0-15.272 0 7.622 7.622 0 0 0 5.353 7.283.523.523 0 0 1 .374.494v3.178Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#347A3F",
  d: "M45.35 36.304h-9.143v-7.257h9.143v7.257Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.78,
  cy: 22.697,
  fill: "#347A3F",
  rx: 10.058,
  ry: 9.978
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.722 44.278h8.861l-8.86-8.861v8.86ZM5.222 33h16.111L31 42.667v16.11A3.222 3.222 0 0 1 27.778 62H5.222A3.221 3.221 0 0 1 2 58.778V36.222A3.211 3.211 0 0 1 5.222 33Zm0 3.222v22.556h22.556V47.5H16.5V36.222H5.222Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgContext);
export { ForwardRef as ReactComponent };